export default {"src":"/_next/static/media/image.6e9330be.svg","height":40,"width":40};